<template>
  <div id="grad" class="temp__flexbox temp__jc--c width--100p py--60 py--40--768">
    <div class="intro mw--1120 px--40">
      <span class="mp--b">SMIRNOFF</span> No.21 Premium <span class="mp--b">VODKA</span> is the number one best&#8288;-&#8288;selling premium Vodka in the world, with countless years of heritage and unmatched quality sold in over 130 countries. It is triple distilled from grain and filtered ten times through charcoal for an <span class="mp--b">EXCEPTIONALLY PURE&#8288;-&#8288;TASTING</span>, smooth&nbsp;spirit. 
    <div class="pt--30">
      <img class="width--100p--768" src="hero/divider-gold.png">
    </div>
    </div>
  </div>
  <div class="temp__flexbox temp__jc--c width--100p pb--20">
    <div class="title mp--m mw--1120 px--40">
    Try our recipes    
    </div>
  </div>
</template>

<script setup>

import dataModel from '../js/model.js';
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1"
  },
});
$(document).ready(function() {
  $('.navbar').css({
    backgroundColor: dataModel[props.brandExperience].ui.primaryColor
  });
  
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.intro {
  font-family: 'Noe Text Book';
  font-size: 22px;
  font-style: italic;
  line-height: 28px;
  color: $color--smirnoff;
  @media (max-width: 750px) {
        font-size: 22px;
    }
}

.mp--b {
  font-family: 'Mark Pro';
  font-weight: bold;
  text-transform: uppercase;
  font-style: initial;
}

.title {
  font-size: 40px;
  color: $color--smirnoff;
  @media (max-width: 750px) {
        font-size: 34px;
    }
}

.mp--m {
  font-family: 'Mark Pro';
  font-weight: 500;
  text-transform: uppercase;
}

</style>